/* global axios */

import ApiClient from '../ApiClient';

class TwentyAPI extends ApiClient {
  constructor() {
    super('integrations/twenty', { accountScoped: true });
  }

  connect(instanceUrl, apiKey) {
    return axios.post(`${this.url}/connect`, {
      instance_url: instanceUrl,
      api_key: apiKey,
    });
  }

  disconnect() {
    return axios.delete(`${this.url}/disconnect`);
  }

  searchRecords(query) {
    return axios.get(`${this.url}/search_records`, { params: { q: query } });
  }

  searchPeople(query) {
    return axios.get(`${this.url}/search_people`, { params: { q: query } });
  }

  searchCompanies(query) {
    return axios.get(`${this.url}/search_companies`, { params: { q: query } });
  }

  searchOpportunities(query) {
    return axios.get(`${this.url}/search_opportunities`, {
      params: { q: query },
    });
  }

  getLinkedRecords(conversationId) {
    return axios.get(`${this.url}/linked_records`, {
      params: { conversation_id: conversationId },
    });
  }

  linkRecord({ conversationId, recordId, recordType, recordName, recordData }) {
    return axios.post(`${this.url}/link_record`, {
      conversation_id: conversationId,
      record_id: recordId,
      record_type: recordType,
      record_name: recordName,
      record_data: recordData || {},
    });
  }

  unlinkRecord(id) {
    return axios.delete(`${this.url}/unlink_record`, { params: { id } });
  }

  getPerson(id) {
    return axios.get(`${this.url}/get_person`, { params: { id } });
  }

  getOpportunity(id) {
    return axios.get(`${this.url}/get_opportunity`, { params: { id } });
  }

  searchOpportunitiesByPerson(personId, query) {
    return axios.get(`${this.url}/search_opportunities_by_person`, {
      params: { person_id: personId, q: query },
    });
  }

  searchOpportunitiesByCompany(companyId, query) {
    return axios.get(`${this.url}/search_opportunities_by_company`, {
      params: { company_id: companyId, q: query },
    });
  }

  createPerson({
    conversationId,
    firstName,
    lastName,
    email,
    companyId,
    phone,
  }) {
    return axios.post(`${this.url}/create_person`, {
      conversation_id: conversationId,
      first_name: firstName,
      last_name: lastName,
      email,
      company_id: companyId,
      phone,
    });
  }

  createCompany(name) {
    return axios.post(`${this.url}/create_company`, { name });
  }

  createOpportunity({ conversationId, name, stage }) {
    return axios.post(`${this.url}/create_opportunity`, {
      conversation_id: conversationId,
      name,
      stage: stage || 'NEW',
    });
  }
}

export default new TwentyAPI();
